export const PAGE_SIZE = 10;
export const ENTERPRISE_CONNECTIONS_GUIDE_URL =
  'https://clerkdev.notion.site/SAML-at-Clerk-Private-Beta-Docs-53c6c83cfbd04c478dfbc2d837f49142';
